<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="806" height="329" viewBox="0 0 806 329" fill="none" style="margin: 0 auto">
    <rect width="806" height="329" fill="white"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="364.955" y="291.28">Заочная форма</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="610.955" y="291.28">Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="289.138" y="250.22">Корректирующий коэффициент<title>Понижающий коэффициент, применяемый в случае, когда общий прогнозируемый объем КЦП по УГСН (НПС) по форме обучения ниже суммы КЦП на предшествующий год по столичным регионам по данной форме обучения.</title>  для</tspan></text>

    <text xmlns="http://www.w3.org/2000/svg" fill="#0288D1" xml:space="preserve" style="white-space: pre" font-family="PT Serif" font-size="12" font-weight="bold" letter-spacing="0em">
	<tspan x="493" y="246" data-tooltip="Понижающий коэффициент, применяемый в случае, когда общий прогнозируемый объем КЦП по УГСН (НПС) по форме обучения ниже суммы КЦП на предшествующий год по столичным регионам по данной форме обучения.">?</tspan>
</text>

    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="404" y="266.22">{{
        getPbData.sprRegionNameGenitive
      }}</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="544.231" y="250.22">Прогнозируемый объем КЦП для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="650" y="266.22">{{
        getPbData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="404" y="218.18">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getPbData.kst3) ? (getPbData.kst3 === 'н.д.' ? 'н.д.': 'x'): getPbData.kst3, 3, 'float', true,  'н.д.', '',) }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#00599B" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" font-weight="bold" letter-spacing="0.01em"><tspan x="650" y="218.18">{{
        getPbData.kcp3
      }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="268" y="213.765">×</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="46.5581"
          letter-spacing="0.01em"><tspan x="514" y="213.765">=</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12"
          font-weight="500" letter-spacing="0.01em"><tspan x="114.955" y="291.28">Заочная форма</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="13"
          font-weight="500" letter-spacing="0.01em"><tspan x="46.1091" y="250.22">КЦП на предшествующий год для</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="13" font-weight="500" letter-spacing="0.01em"><tspan x="154" y="266.22">{{
        getPbData.sprRegionNameGenitive
      }}</tspan></text>
    <text xmlns="http://www.w3.org/2000/svg" text-anchor="middle" fill="#263238" xml:space="preserve"
          style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="154" y="218.18">{{
        getPbData.kcpT3
      }}</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="29" y="151.04">Заочная форма</tspan></text>
    <line x1="30" y1="117.5" x2="775" y2="117.5" stroke="#CFD8DC"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="30" y="96.24">Прогноз потребности в подготовке кадров осуществлен по УГСН (НПС) в целом
</tspan></text>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16"
          letter-spacing="0.01em"><tspan x="30" y="77.24">{{
        getPbData.sprKcpGroupSprUslName
      }}: {{ getPbData.sprKcpGroupId }} {{ getPbData.sprKcpGroupName }}.</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22"
          letter-spacing="0.01em"><tspan x="30" y="43.68">Прогнозирование общего объема КЦП для столичного региона</tspan></text>
  </svg>
</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "Pb3",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getPbData: {
        "id": 0,
        "sprKcpGroupId": "string",
        "sprKcpGroupName": "string",
        "sprKcpGroupSprUslName": "string",
        "sprRegionId": "string",
        "sprRegionName": "string",
        "sprRegionNameGenitive": "string",
        "kcpT1": 0,
        "kst1": 0,
        "kcp1": 0,
        "kcpT2": 0,
        "kst2": 0,
        "kcp2": 0,
        "kcpT3": 0,
        "kst3": 0,
        "kcp3": 0
      }
    }
  },
  async created() {
    await this.getPbSvg();
  },
  methods: {
    async getPbSvg() {
      try {
        const res = await request({
          endpoint: `/api/information/getPb?kcpGroupId=${this.kcpGroupId}&regionId=${this.regionId}`,
          method: 'get',
        });
        if (res.status === 200) {
          console.log('getPbSvg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>